import React, { useEffect /* , useState */ } from 'react';
import PropTypes from 'prop-types';
import { /* Button, */ Card, Col, Row } from 'react-bootstrap';
/* import { projectService } from 'services'; */
import corner4 from 'assets/img/illustrations/corner-2.png';
/* import { useForm } from 'react-hook-form'; */
import Input from 'components/common/Input';
import Background from 'components/common/Background';
import { /* convertToNumber, */ currency, noCurrency, percent } from 'helpers/utils';
import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
dayjs.extend(isSameOrAfter);

const TypeContract = ({ watch, register, setValue, errors }) => {
 const handleFieldChange = ({ target: { name, value } }) =>
  setValue(name, name !== 'amount' ? percent(value) : currency(value, true));

 const setFrequency = ({ type, frequency, start, end, amount }) => {
  if (!start) return [];
  const nominal = noCurrency(amount);
  const freq = frequency % 2;

  // Calcular el total de días entre start y fechafin
  const daysTotal = dayjs(end).diff(start, 'd');

  // Obtener el día del mes de start
  const dayStart = dayjs(start).date();

  // Calcular la próxima fecha de corte
  const nextCutDate = !freq ? dayjs(start).endOf('month') : dayStart > 15 ? dayjs(start).endOf('month') : dayjs(start).date(15);

  // Calcular los días trabajados hasta la próxima fecha de corte
  const dayWork = dayjs(nextCutDate).diff(start, 'd');

  // ----------------------- Quincena -----------------------
  if (end) {
   // Calcular el valor diario
   const dayValue = nominal / (type === 'Laboral' ? 30 : daysTotal);

   // Calcular el primer pago
   const firstPay = dayWork * dayValue;

   // Calcular el número de meses entre start y fechafin multiplicado por 2 (quincenas por mes)
   const meses = dayjs(end).diff(start, 'month') * (freq ? 2 : 1) - 1;

   // Calcular el pago nominal mensual
   const nomifnalPay = type === 'Laboral' ? nominal / (freq ? 2 : 1) : (nominal - firstPay) / meses;

   let nextDate = nextCutDate;

   const datesArray = Array.from({ length: meses }, (_, i) => {
    const num = i + 2;

    if (frequency == 15) {
     const isFortnight = dayjs(nextDate).date() == 15 ?? false;
     nextDate = isFortnight
      ? dayjs(nextDate).endOf('month').format('YYYY-MM-DD')
      : dayjs(nextDate).add(1, 'month').date(15).format('YYYY-MM-DD');

     return { fee: num, type: 'Pago', amount: nomifnalPay, date: nextDate };
    } else {
     nextDate = dayjs(nextDate).add(1, 'month').endOf('month').format('YYYY-MM-DD');
     return { fee: num, type: 'Pago', amount: nomifnalPay, date: nextDate };
    }
   });

   // Devolver un array con la información
   console.log('aqui va el array ', datesArray);
   datesArray.unshift({ fee: 1, type: 'Pago', amount: firstPay, date: nextCutDate.format('YYYY-MM-DD') });

   return datesArray;
  } else {
   // Si no hay fecha de fin, calcular solo para la quincena

   // Calcular el valor diario
   const dayValue = nominal / (freq ? 15 : 30); // Puedes considerar calcular los días reales en el mes

   // Calcular el primer pago
   const firstPay = dayWork * dayValue;

   // Devolver un array con la información
   return [{ fee: 1, type: 'Pago', amount: firstPay, date: nextCutDate.format('YYYY-MM-DD') }];
  }
 };

 useEffect(() => {
  const subscription = watch((values, { name }) => {
   if (name === undefined) return;
   console.log('aqui van los cambios ', values);
   if (name === 'activity') return setValue('detail', `contrato_${values.type}_${values.activity}`);
   if (/type|frequency|end|start/.test(name)) return setValue('financing', setFrequency(values));
  });
  return () => subscription.unsubscribe();
 }, [watch]);

 return (
  <>
   <Card className="bg-100 shadow-none border mb-0">
    <Background
     image={corner4}
     className="bg-card"
     style={{
      borderTopRightRadius: '0.375rem',
      borderBottomRightRadius: '0.375rem'
     }}
    />
    <Card.Body className="fs--1 position-relative">
     <Row className="justify-content-md-center fs--2 px-2 g-2 pt-2">
      <Col xs={12} md={{ span: 3, offset: 3 }}>
       <Input
        type="select"
        label="Pagos"
        errors={errors}
        name="frequency"
        placeholder="Frecuencia"
        formGroupProps={{ as: Row }}
        formLabelProps={{ className: 'text-end text-md-start', column: true, xs: 5, md: 12 }}
        formColumnProps={{ xs: { span: 6, offset: 1 }, md: { span: 12, offset: 0 } }}
        options={[
         { label: 'Mensual', value: '0' },
         { label: 'Quincenal', value: '15' }
        ]}
        formControlProps={{
         ...register('frequency', { required: true }),
         className: 'text-center',
         size: 'sm'
        }}
       />
      </Col>
      <Col xs={12} md={{ span: 3, offset: 3 }}>
       <Input
        type="text"
        label="Comision"
        placeholder="Opcional"
        name="commissions.person"
        errors={errors}
        formGroupProps={{ as: Row }}
        formLabelProps={{ className: 'text-end text-md-start', column: true, xs: 5, md: 12 }}
        formColumnProps={{ xs: { span: 6, offset: 1 }, md: { span: 12, offset: 0 } }}
        formControlProps={{
         ...register('commissions.person'),
         className: 'text-center',
         autoComplete: 'off',
         size: 'sm',
         onChange: handleFieldChange
        }}
       />
      </Col>

      <div className="border-dashed border-bottom my-3" />

      <Col xs={12} md="3">
       <Input
        type="text"
        name="activity"
        label={watch('type') == 'Prestacion' ? 'Actividad' : 'Cargo'}
        errors={errors}
        placeholder="Nombre de Actividad"
        formGroupProps={{ as: Row }}
        formLabelProps={{ className: 'text-end text-md-start', column: true, xs: 5, md: 12 }}
        formColumnProps={{ xs: { span: 6, offset: 1 }, md: { span: 12, offset: 0 } }}
        formControlProps={{
         ...register('activity', {
          required: true,
          validate: value => !/[^a-zA-Z]/g.test(value) || 'Caracteres invalidos',
          minLength: { value: 5, message: 'Pocos caracteres' }
         }),
         className: 'text-center',
         autoComplete: 'off',
         disabled: false,
         maxLength: 20,
         size: 'sm'
        }}
       />
      </Col>
      <Col xs={12} md="3">
       <Input
        type="text"
        errors={errors}
        label={watch('type') == 'Prestacion' ? 'Monto total' : 'Salario'}
        name="amount"
        placeholder="Monto"
        formGroupProps={{ as: Row }}
        formLabelProps={{ className: 'text-end text-md-start', column: true, xs: 5, md: 12 }}
        formColumnProps={{ xs: { span: 6, offset: 1 }, md: { span: 12, offset: 0 } }}
        formControlProps={{
         ...register('amount', {
          required: true,
          validate: value => /\$|^0/.test(value) || 'Valor invalido'
         }),
         className: 'text-center',
         autoComplete: 'off',
         disabled: false,
         alt: 'currency',
         size: 'sm',
         onChange: handleFieldChange
        }}
       />
      </Col>

      <Col xs={12} md="3">
       <Input
        type="simple-date"
        label="Fecha de Inicio"
        name="start"
        errors={errors}
        formGroupProps={{ as: Row }}
        formLabelProps={{ className: 'text-end text-md-start', column: true, xs: 5, md: 12 }}
        formColumnProps={{ xs: { span: 6, offset: 1 }, md: { span: 12, offset: 0 } }}
        formControlProps={{
         ...register('start', {
          required: true,
          validate: value => dayjs(value).isSameOrAfter(dayjs(), 'days') || 'La fecha debe ser igual o mayor a la actual'
         }),
         className: 'text-center',
         autoComplete: 'off',
         disabled: false,
         size: 'sm'
        }}
       />
      </Col>
      <Col xs={12} md="3">
       <Input
        type="simple-date"
        label="Fecha Final"
        name="end"
        errors={errors}
        formGroupProps={{ as: Row }}
        formLabelProps={{ className: 'text-end text-md-start', column: true, xs: 5, md: 12 }}
        formColumnProps={{ xs: { span: 6, offset: 1 }, md: { span: 12, offset: 0 } }}
        formControlProps={{
         ...register('end', {
          required: true,
          validate: value => value > watch('start') || 'La fecha debe ser menor a la fecha inicial'
         }),
         className: 'text-center',
         autoComplete: 'off',
         disabled: false,
         size: 'sm'
        }}
       />
      </Col>
     </Row>
    </Card.Body>
   </Card>
  </>
 );
};

TypeContract.propTypes = {
 watch: PropTypes.func,
 register: PropTypes.func,
 setValue: PropTypes.func,
 errors: PropTypes.object
};

export default TypeContract;
